export const headerKeywords = [
  '근무일자',
  '이름',
  '근무스케줄',
  '출근시간',
  '퇴근시간',
  '출근판정',
  '퇴근판정',
  '휴일근무시간',
  '정상근무시간',
  '수정 사유',
  '연장근무시간',
];
